import type { RefObject } from 'react'
import { MapPin, VectorPolygon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ButtonGroup } from '@/components/ui/button-group'
import type { ActiveTool } from './georeference-step'

type GeoreferenceHeaderProps = {
  activeTool: ActiveTool
  onSwitchToPin: () => void
  onSwitchToDraw: () => void
  geocoderContainerRef: RefObject<HTMLDivElement>
}

// Fragment so the parent's flex `gap-4` still applies between each block individually.
export const GeoreferenceHeader = ({
  activeTool,
  onSwitchToPin,
  onSwitchToDraw,
  geocoderContainerRef,
}: GeoreferenceHeaderProps) => {
  return (
    <>
      <div className="flex items-center gap-2">
        <ButtonGroup>
          <Button
            type="button"
            variant={activeTool === 'pin' ? 'default' : 'outline'}
            onClick={onSwitchToPin}
          >
            <MapPin className="h-3.5 w-3.5" />
            Pin
          </Button>
          <Button
            type="button"
            variant={activeTool === 'draw' ? 'default' : 'outline'}
            onClick={onSwitchToDraw}
          >
            <VectorPolygon className="h-3.5 w-3.5" />
            Draw area
          </Button>
        </ButtonGroup>

        <div ref={geocoderContainerRef} className="documents-geocoder flex-1" />
      </div>

      {activeTool == 'draw' && (
        <p className="text-xs text-muted-foreground">
          Click the map to place points. Click the last point again to close the area. Click a point
          to remove it.
        </p>
      )}
      {activeTool == 'pin' && (
        <p className="text-xs text-muted-foreground">
          Click once on the map to drop a single point. Or search an address to place it for you.
        </p>
      )}
    </>
  )
}
